
import React, {
    useEffect,
    useRef,
    useState,
} from "react";

import {
    BrowserMultiFormatReader,
} from "@zxing/browser";

import "./ScanQr.css";

export default function ScanQr({
    onClose,
    onScanSuccess,
    setOcrLoading,
}) {

    const videoRef = useRef(null);
    const isClosingRef = useRef(false);


    const controlsRef = useRef(null);
const permissionStreamRef = useRef(null);


    const [result, setResult] =
        useState("");

    const [error, setError] =
        useState("");

    const [contactData, setContactData] =
        useState(null);

    const [scanMessage, setScanMessage] =
        useState("Scanning QR...");






    
// const handleClose = () => {

//     if (isClosingRef.current) {
//         return;
//     }

//     isClosingRef.current = true;

//     try {

//         controlsRef.current?.stop();
//         controlsRef.current = null;

//         permissionStreamRef.current
//             ?.getTracks()
//             .forEach(track => track.stop());

//         permissionStreamRef.current = null;

//         if (
//             videoRef.current &&
//             videoRef.current.srcObject
//         ) {

//             videoRef.current.srcObject
//                 .getTracks()
//                 .forEach(track => track.stop());

//             videoRef.current.pause();
//             videoRef.current.srcObject = null;
//         }

//     } catch (e) {

//         console.log("Close error", e);
//     }

//     onClose?.();
// };


const handleClose = () => {

    setOcrLoading?.(false);

    if (isClosingRef.current) {
        return;
    }

    isClosingRef.current = true;

    try {

        controlsRef.current?.stop();
        controlsRef.current = null;

        permissionStreamRef.current
            ?.getTracks()
            .forEach(track => track.stop());

        permissionStreamRef.current = null;

        if (
            videoRef.current &&
            videoRef.current.srcObject
        ) {

            videoRef.current.srcObject
                .getTracks()
                .forEach(track => track.stop());

            videoRef.current.pause();
            videoRef.current.srcObject = null;
        }

    } catch (e) {

        console.log("Close error", e);
    }

    onClose?.();
};
    /* ========================================
      PARSE VCARD
    ======================================== */

    const parseVCard = (vcardText) => {

        const lines =
            vcardText.split("\n");

        const contact = {};

        lines.forEach((line) => {

            line = line.trim();

            /* FULL NAME */

            if (line.startsWith("FN:")) {

                contact.name =
                    line.replace("FN:", "");
            }

            /* FALLBACK NAME */

            if (
                line.startsWith("N:") &&
                !contact.name
            ) {

                const rawName =
                    line.replace("N:", "");

                const parts =
                    rawName.split(";");

                const lastName =
                    parts[0] || "";

                const firstName =
                    parts[1] || "";

                contact.name =
                    `${firstName} ${lastName}`.trim();
            }

            /* COMPANY */

            if (line.startsWith("ORG:")) {

                contact.company =
                    line.replace("ORG:", "");
            }

            /* TITLE */

            if (line.startsWith("TITLE:")) {

                contact.title =
                    line.replace("TITLE:", "");
            }

            /* EMAIL */

            if (line.includes("EMAIL")) {

                contact.email =
                    line.split(":")[1];
            }

            /* WEBSITE */

            if (line.startsWith("URL:")) {

                const value =
                    line.replace("URL:", "");

                if (value.includes("@")) {

                    contact.email = value;

                } else {

                    contact.website = value;
                }
            }

            /* PHONE */

            if (line.includes("TEL")) {

                if (!contact.phones) {

                    contact.phones = [];
                }

                contact.phones.push(
                    line.split(":")[1]
                );
            }

            /* ADDRESS */

            if (line.startsWith("ADR:")) {

                contact.address =
                    line.split(":")[1];
            }
        });

        return contact;
    };


    

    /* ========================================
      START SCANNER
    ======================================== */

    useEffect(() => {

        const codeReader =
            new BrowserMultiFormatReader();

controlsRef.current = null;

        let scanned = false;

//         async function startScanner() {

//             try {

//                 setScanMessage(
//                     "Scanning QR..."
//                 );

//                 /* ASK CAMERA PERMISSION */

//        permissionStreamRef.current =
//     await navigator.mediaDevices.getUserMedia({

//         video: {
//             facingMode: {
//                 ideal: "environment",
//             },
//             width: {
//                 ideal: 1920,
//             },
//             height: {
//                 ideal: 1080,
//             },
//         },
//     });



//                 /* GET CAMERA DEVICES */

//                 const devices =
//                     await BrowserMultiFormatReader.listVideoInputDevices();

//                 if (!devices.length) {

//                     setError(
//                         "No camera found"
//                     );

//                     return;
//                 }

//                 /* BACK CAMERA */

//                 const backCamera =
//                     devices.find((device) =>
//                         device.label
//                             .toLowerCase()
//                             .includes("back")
//                     );

//                 const selectedDeviceId =
//                     backCamera
//                         ? backCamera.deviceId
//                         : devices[0].deviceId;

//                 /* START SCANNER */

//                 controlsRef.current =
//                     await codeReader.decodeFromVideoDevice(
//                         selectedDeviceId,
//                         videoRef.current,
//                         (scanResult, err) => {

//                             /* IGNORE ZXING ERRORS */

//                             if (err) {
//                                 return;
//                             }

//                             /* PREVENT MULTIPLE SCANS */

//                             if (
//                                 scanResult &&
//                                 !scanned
//                             ) {

//                                 scanned = true;

//                                 const text =
//                                     scanResult.getText();

//                                 console.log(
//                                     "QR RESULT:",
//                                     text
//                                 );

//                                 setResult(text);

//                                 /* VCARD */

//                                 if (
//                                     text.includes(
//                                         "BEGIN:VCARD"
//                                     )
//                                 ) {

//                                     setScanMessage(
//                                         "Contact QR Detected ✅"
//                                     );

//                                     const parsedContact =
//                                         parseVCard(text);

//                                     setContactData(parsedContact);

//                                     if (onScanSuccess) {
//                                         onScanSuccess(parsedContact);
//                                     }

//                                   setTimeout(() => {
//     handleClose();
// }, 500);

//                                 } else {

//                                     setScanMessage(
//                                         "Unsupported QR ❌"
//                                     );
//                                 }

//                                 /* SAFELY STOP CAMERA */

                               
//                             }
//                         }
//                     );

//             } catch (err) {

//                 console.error(err);

//                 setError(
//                     "Camera access failed. Allow permissions and use HTTPS."
//                 );
//             }
//         }


async function startScanner() {

    try {

        setOcrLoading?.(true);

        setScanMessage(
            "Scanning QR..."
        );

        /* ASK CAMERA PERMISSION */

        permissionStreamRef.current =
            await navigator.mediaDevices.getUserMedia({

                video: {
                    facingMode: {
                        ideal: "environment",
                    },
                    width: {
                        ideal: 1920,
                    },
                    height: {
                        ideal: 1080,
                    },
                },
            });

        /* GET CAMERA DEVICES */

        const devices =
            await BrowserMultiFormatReader.listVideoInputDevices();

        if (!devices.length) {

            setOcrLoading?.(false);

            setError(
                "No camera found"
            );

            return;
        }

        /* BACK CAMERA */

        const backCamera =
            devices.find((device) =>
                device.label
                    .toLowerCase()
                    .includes("back")
            );

        const selectedDeviceId =
            backCamera
                ? backCamera.deviceId
                : devices[0].deviceId;

        /* CAMERA READY */

        setOcrLoading?.(false);

        /* START SCANNER */

        controlsRef.current =
            await codeReader.decodeFromVideoDevice(
                selectedDeviceId,
                videoRef.current,
                (scanResult, err) => {

                    /* IGNORE ZXING ERRORS */

                    if (err) {
                        return;
                    }

                    /* PREVENT MULTIPLE SCANS */

                    if (
                        scanResult &&
                        !scanned
                    ) {

                        scanned = true;

                        setOcrLoading?.(false);

                        const text =
                            scanResult.getText();

                        console.log(
                            "QR RESULT:",
                            text
                        );

                        setResult(text);

                        /* VCARD */

                        if (
                            text.includes(
                                "BEGIN:VCARD"
                            )
                        ) {

                            setScanMessage(
                                "Contact QR Detected ✅"
                            );

                            const parsedContact =
                                parseVCard(text);

                            setContactData(
                                parsedContact
                            );

                            if (onScanSuccess) {

                                onScanSuccess(
                                    parsedContact
                                );
                            }

                            setTimeout(() => {

                                handleClose();

                            }, 500);

                        } else {

                            setScanMessage(
                                "Unsupported QR ❌"
                            );
                        }
                    }
                }
            );

    } catch (err) {

        setOcrLoading?.(false);

        console.error(err);

        setError(
            "Camera access failed. Allow permissions and use HTTPS."
        );
    }
}

        startScanner();

//         return () => {

//             try {

//                if (controlsRef.current) {

//     controlsRef.current.stop();
// }

//               if (
//     videoRef.current &&
//     videoRef.current.srcObject
// ) {

//     const tracks =
//         videoRef.current.srcObject.getTracks();

//     tracks.forEach(track =>
//         track.stop()
//     );

//     videoRef.current.srcObject = null;
// }   

//             } catch (e) {

//                 console.log(
//                     "Cleanup ignore"
//                 );
//             }
//         };


return () => {

    setOcrLoading?.(false);

    try {

        if (controlsRef.current) {

            controlsRef.current.stop();
            controlsRef.current = null;
        }

        permissionStreamRef.current
            ?.getTracks()
            .forEach(track => track.stop());

        permissionStreamRef.current = null;

        if (
            videoRef.current &&
            videoRef.current.srcObject
        ) {

            videoRef.current.srcObject
                .getTracks()
                .forEach(track => track.stop());

            videoRef.current.srcObject = null;
        }

    } catch (e) {

        console.log("Cleanup ignore");
    }
};


    }, []);

    return (

        <div
            className="scanner-container"
            style={{
                position: "fixed",
                inset: 0,
                background: "#000",
                zIndex: 99999,
            }}
        >

            <button
  className="back-btn"
  onClick={handleClose}
>
  ✕
</button>



            {/* CAMERA */}

            <div className="camera-box">

                <video
                    ref={videoRef}
                    autoPlay
                    muted
                    playsInline
                    className="scanner-video"
                />

                <div className="scan-overlay"></div>

            </div>

            {/* STATUS */}

            <div className="scanner-status">

                <p>{scanMessage}</p>

            </div>

            {/* ERROR */}

            {error && (

                <div className="error-text">

                    {error}

                </div>
            )}





            {/* RAW RESULT */}

            {!contactData && result && (

                <div className="result-box">

                    <h3>
                        Scanned Result:
                    </h3>

                    <pre className="result-text">

                        {result}

                    </pre>

                </div>
            )}

        </div>
    );
}